import * as actions from "../constants/ActionTypes";

export const setItemStatus = (itemId, isCollapsed) => ({
  type: actions.SET_COLLAPSIBLE_ITEM_STATUS,
  payload: {
    itemId,
    isCollapsed,
  },
});
